import isPredeliveryAndTotalPaymentDueZero from "../../../helpers/isPredeliveryAndTotalPaymentDueZero";
import isLoanClosed from "../../../helpers/isLoanClosed";
var getPayLaterMonthlyDataSections = function (accountSummary, autopayStatus, t) {
    var billing = accountSummary.billing, credit = accountSummary.credit, installment = accountSummary.installment, conditions = accountSummary.conditions;
    var isClosed = isLoanClosed(conditions);
    var isPredelivery = isPredeliveryAndTotalPaymentDueZero(conditions, billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue);
    var showUnavailableText = isClosed || isPredelivery;
    var unavailableText = t("error.uiComponent");
    return {
        dataSections: [
            {
                sectionName: "loan-summary",
                heading: t("grid.titles.loanSummary"),
                dataElements: [
                    {
                        label: t("grid.labels.loanStartDate"),
                        value: installment === null || installment === void 0 ? void 0 : installment.startDate,
                        type: "date",
                    },
                    {
                        label: t("grid.labels.loanTerm"),
                        value: installment === null || installment === void 0 ? void 0 : installment.loanTerm,
                        type: "months",
                    },
                    {
                        label: t("grid.labels.interestRate"),
                        value: installment === null || installment === void 0 ? void 0 : installment.interestRate,
                        type: "percentage",
                    },
                ],
            },
            {
                sectionName: "payments",
                heading: t("grid.titles.payments"),
                dataElements: [
                    {
                        label: t("grid.labels.nextPaymentDate"),
                        value: showUnavailableText
                            ? unavailableText
                            : billing === null || billing === void 0 ? void 0 : billing.nextPaymentDate,
                        type: showUnavailableText ? "text" : "date",
                    },
                    {
                        label: t("grid.labels.nextAmountDue"),
                        value: showUnavailableText
                            ? unavailableText
                            : billing === null || billing === void 0 ? void 0 : billing.totalMinimumPaymentDue,
                        type: showUnavailableText ? "text" : "amount",
                        toolTipText: t("grid.labels.nextAmountMothlyTooltip"),
                    },
                    {
                        label: t("grid.labels.lastPaymentDate"),
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentDate,
                        type: "date",
                    },
                    {
                        label: t("grid.labels.lastPaymentAmount"),
                        value: billing === null || billing === void 0 ? void 0 : billing.lastPaymentAmount,
                        type: "amount",
                    },
                    {
                        label: t("grid.labels.autoPayStatus.text"),
                        value: autopayStatus.enrollment
                            ? t("grid.labels.autoPayStatus.on")
                            : t("grid.labels.autoPayStatus.off"),
                        type: "text",
                    },
                ],
            },
            {
                sectionName: "loan-information",
                heading: t("grid.titles.loanInformation"),
                dataElements: [
                    {
                        label: t("grid.labels.estimatedPayoffAmount"),
                        value: credit === null || credit === void 0 ? void 0 : credit.currentBalance,
                        type: "amount",
                        toolTipText: t("grid.labels.estimatedPayoffAmountTooltip"),
                    },
                    {
                        label: t("grid.labels.monthlyLoanPayment"),
                        value: billing === null || billing === void 0 ? void 0 : billing.fixedPaymentAmount,
                        type: "amount",
                    },
                    {
                        label: t("grid.labels.termRemaining"),
                        value: installment === null || installment === void 0 ? void 0 : installment.termRemaining,
                        type: "months",
                    },
                    {
                        label: t("grid.labels.loanEndDate"),
                        value: installment === null || installment === void 0 ? void 0 : installment.endDate,
                        type: "date",
                    },
                ],
            },
        ],
    };
};
export default getPayLaterMonthlyDataSections;
//# sourceMappingURL=getPayLaterMonthlyDataSections.js.map